<div class="custom-search-dropdown" [ngClass]="wrapperClasses" [class.disabled]="disabled">

  <!-- INPUT FIELD -->
  <div
    class="dropdown-input"
    [ngClass]="{'value-selected' : control.value.length, 'all-selected': control.value.includes('-1')}"
    (click)="toggleOpen()"
  >
    <span class="placeholder">{{ placeholder }}</span>

    <div class="selected-value-container">
      <span *ngIf="control.value.length" class="selected-value-text">
        {{ getOptionsText() }}
      </span>

      <div *ngIf="control.value.length > 1" class="selected-items-count">
        {{ getSelectedItemsText() }}
      </div>
    </div>

    <div class="arrow"></div>
  </div>

  <!-- DROPDOWN PANEL -->
  <div class="dropdown-panel" *ngIf="isOpen">

    <!-- SEARCH -->
    <div class="search-container">
      <input
        type="text"
        name="dropdown-search"
        class="search-box"
        [placeholder]="searchPlaceholder"
        [(ngModel)]="searchTerm"
        (input)="filterOptions()"
      />

      <div class="search-icon">
        <img src="/Content/Images/icons/lupa.svg" alt="">
      </div>
    </div>

    <!-- OPTIONS -->
    <div class="options-list">
      <div *ngFor="let opt of filteredOptions" class="option-item">
        <mat-checkbox
          [ngClass]="{'all-option' : opt.key==='-1'}"
          [(ngModel)]="opt.isChecked"
          (change)="onOptionChange(opt)">
          <span [innerHTML]="opt.highlighted || opt.value"></span>
        </mat-checkbox>
      </div>

      <!-- NO RESULTS -->
      <div *ngIf="!filteredOptions.length" class="no-results">
        {{ noResultsText }}
      </div>
    </div>

    <!-- FOOTER -->
    <div class="footer-buttons" *ngIf="!immediateSelect">
      <button
        mat-flat-button
        color="primary"
        (click)="submitSelection()"
        class="btn-md submit-filter save-button"
      >
        {{ submitButtonText }}
      </button>
      <a (click)="clearSelection()">
        {{ clearButtonText }}
      </a>
    </div>

  </div>
</div>
